"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = {
  STREAM_TIMEOUT: 'STREAM_TIMEOUT',
  ECONNABORTED: 'ECONNABORTED' // axios timeout error code
};
//# sourceMappingURL=errorCodes.js.map